import ErrorPage from '../../pages/ErrorPage';
import React from 'react';

const CLIENT_ERROR = 500;
const CLIENT_ERROR_MESSAGE = 'Something went wrong. Please try again!';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
    };
  }

  static getDerivedStateFromError(error) {
    return {
      error: { status: CLIENT_ERROR, message: CLIENT_ERROR_MESSAGE },
    };
  }

  componentDidCatch(error, errorInfo) {
    console.log(error, errorInfo);
  }

  render() {
    if (this.state.error) {
      return <ErrorPage status={this.state.error.status} message={this.state.error.message} />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
